import { useEffect, useState } from 'react';
import { Header } from '../header/header';
import { TeamModel, UserModel } from '../../dto/reporting-models';
import { reportingService } from '../../services/reporting-service';
import { useMsal } from '@azure/msal-react';
import { scopes } from '../../authConfig';
import { GetAccessToken } from '../../utils/auth-utils';
import { App, Button, List, Modal, Row } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import Title from 'antd/es/typography/Title';
import { TeamCard } from './team-card';
import { TeamForm } from './team-form';

export const Ums = () => {
  const { notification } = App.useApp();
  const { instance, inProgress } = useMsal();
  const [displayAddButton, shouldDisplayAddButton] = useState<boolean>(true);
  const [isSpinning, setIsSpinning] = useState(false);
  const [teamOptions, setTeamOptions] = useState<TeamModel[]>([]);
  const [users, setUsers] = useState<UserModel[]>([]);
  const [shoudlDisplayTeamForm, setShouldDisplayTeamForm] = useState<boolean>(false);
  const [newTeam, setNewTeam] = useState<TeamModel | null>(null);
  const [usersWithoutTeam, setUsersWithoutTeam] = useState<UserModel[]>([]);
  const [openModal, setOpenModal] = useState<boolean>(false);

  useEffect(() => {
    fetchInfo();
  }, []);

  const fetchInfo = async () => {
    setIsSpinning(true);

    const token = await GetAccessToken(instance, inProgress, scopes.salesAppointmentApi);
    const teams = await reportingService.getTeamsAsync(token.accessToken);
    setTeamOptions(teams);
    const users = await reportingService.getUsersAsync(token.accessToken);
    setUsers(users);
    setUsersWithoutTeam(users.filter((u) => u.teamId === null).filter((u) => teams?.find((t) => t.leadId === u.id) === undefined));

    setIsSpinning(false);
  };

  const submitTeam = async (team: TeamModel, members: UserModel[]) => {
    const token = await GetAccessToken(instance, inProgress, scopes.salesAppointmentApi);
    let id = team.id;
    if (id === 0) {
      team = await reportingService.postTeamAsync(token.accessToken, team);
      id = team.id;
    } else {
      await reportingService.updateTeamAsync(token.accessToken, team);
    }
    await reportingService.modifyMembersAsync(
      token.accessToken,
      id,
      members.map((m) => m.id)
    );
    await fetchInfo();
    shouldDisplayAddButton(true);
    setShouldDisplayTeamForm(false);
    notification.success({
      message: 'Success',
      description: `Team ${team.name} has been successfully saved.`,
    });
  };

  const deleteTeam = async (teamId: number) => {
    const token = await GetAccessToken(instance, inProgress, scopes.salesAppointmentApi);
    await reportingService.deleteTeamAsync(token.accessToken, teamId);
    setTeamOptions(teamOptions.filter((t) => t.id !== teamId));
  };

  const addTeam = () => {
    const createdTeam = {
      id: 0,
      leadId: '',
      name: '',
    } as TeamModel;
    setNewTeam(createdTeam);
    setShouldDisplayTeamForm(true);
    shouldDisplayAddButton(false);
  };

  return (
    <>
      <Header />
      <div className="container flex-admin-vertical-container" style={{ width: 900 }}>
        <Row justify="space-between" align="bottom" style={{ marginBottom: '20px' }}>
          <Title level={4} style={{ marginBottom: 0 }}>
            Team Management
          </Title>
          <div>
            <Button type="default" loading={isSpinning} onClick={() => setOpenModal(true)} style={{ marginRight: '10px' }}>
              View {usersWithoutTeam.length} Users Without Team
            </Button>
            <Button type="primary" loading={isSpinning} disabled={!displayAddButton} onClick={addTeam} icon={<PlusOutlined />}>
              Add Team
            </Button>
          </div>
        </Row>

        {shoudlDisplayTeamForm && (
          <TeamForm
            teamMembers={[]}
            team={newTeam!}
            users={users}
            usersWithoutTeam={usersWithoutTeam}
            onSubmit={submitTeam}
            cancel={() => {
              setShouldDisplayTeamForm(false);
              shouldDisplayAddButton(true);
              setNewTeam(null);
            }}
          />
        )}
        {teamOptions?.map((team) => (
          <TeamCard key={team.id} team={team} usersWithoutTeam={usersWithoutTeam} users={users} shouldDisplayAddButton={shouldDisplayAddButton} onSubmit={submitTeam} deleteTeam={deleteTeam} />
        ))}
      </div>
      <Modal title="Users Without Team" open={openModal} onCancel={() => setOpenModal(false)} footer={null}>
        <List
          style={{ width: '100%' }}
          size="small"
          bordered
          dataSource={usersWithoutTeam.map((u) => ({
            id: u.id,
            name: u.fullName,
          }))}
          loading={isSpinning}
          renderItem={(item) => (
            <List.Item key={item.id}>
              <List.Item style={{ padding: 0 }}>{item.name}</List.Item>
            </List.Item>
          )}
        />
      </Modal>
    </>
  );
};
